import { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import "../styles/ReportEventModal.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CATEGORIES = [
  { value: "INCORRECT_DATA", label: "Nieprawdziwe/nieaktualne dane" },
  { value: "SPAM_SCAM", label: "Spam / reklama / scam" },
  { value: "HATE_VIOLENCE", label: "Treści nienawistne / przemoc" },
  { value: "SEXUAL", label: "Treści seksualne / nagość" },
  { value: "ILLEGAL", label: "Nielegalne / naruszenie prawa" },
  { value: "COPYRIGHT", label: "Naruszenie praw autorskich / znaków" },
  { value: "IMPERSONATION", label: "Podszywanie się / fałszywy organizator" },
  { value: "EVENT_OWNER_REPORT", label: "Jestem organizatorem tego wydarzenia i nie chcę aby było widoczne na stronie" },
  { value: "OTHER", label: "Inne" },
];

export default function ReportEventModal({
  show,
  onClose,
  eventId,
  isAuthenticated,
  authToken, // jeśli używasz JWT
//   getCaptchaToken, // async () => string; dla anon, np. Turnstile/hCaptcha
}) {
  const [category, setCategory] = useState("INCORRECT_DATA");
  const [description, setDescription] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const canSubmit = useMemo(() => {
    if (!confirm) return false;
    if (!category) return false;
    if ((description || "").trim().length < 20) return false;
    return true;
  }, [confirm, category, description]);

  if (!show) return null;
 
  const submit = async () => {
    setError("");
    setLoading(true);

    try {
    //   let captchaToken = null;
    //   if (!isAuthenticated) {
    //     captchaToken = await getCaptchaToken?.();
    //     if (!captchaToken) {
    //       setLoading(false);
    //       setError("Potwierdź captcha, aby wysłać zgłoszenie.");
    //       return;
    //     }
    //   }

      const res = await fetch(`${API_BASE}/api/events/${eventId}/reports/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
        },
        body: JSON.stringify({
          category,
          description: description.trim(),
        //   captcha_token: captchaToken,
        }),
      });

      if (res.status === 429) {
        setError("Zbyt wiele zgłoszeń w krótkim czasie. Spróbuj ponownie później.");
        setLoading(false);
        return;
      }

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data?.detail || "Nie udało się wysłać zgłoszenia.");
        setLoading(false);
        return;
      }

      setSuccess(true);
      setLoading(false);
    } catch (e) {
      setError("Błąd sieci. Spróbuj ponownie.");
      setLoading(false);
    }
  };

  return createPortal(
  <div
    className="rv-modal"
    role="dialog"
    aria-modal="true"
    tabIndex={-1}
    onMouseDown={(e) => {
      // klik w backdrop zamyka
      if (e.target === e.currentTarget) onClose();
    }}
  >
    <div className="rv-modal__dialog" role="document">
      <div
        className="rv-modal__content"
        onMouseDown={(e) => e.stopPropagation()} // klik w środek NIE zamyka
      >
        <div className="rv-modal__glass" />
        <div className="rv-modal__panel">
          <button
            type="button"
            className="rv-modal__close"
            onClick={onClose}
            aria-label="Zamknij"
          />

          <div className="rv-modal__body">
            <h3 className="rv-modal__title">Zgłoś naruszenie</h3>
            <p className="rv-modal__subtitle">
              Zgłoszenie trafi do administracji i zostanie zweryfikowane.
            </p>

            {success ? (
              <div className="alert alert-success mb-0">
                Zgłoszenie zostało wysłane. Administracja strony rozpatrzy twoje zgłoszenie.
              </div>
            ) : (
              <>
                <div className="rv-field">
                  <label className="rv-label">Kategoria</label>
                  <select
                    className="rv-input"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    {CATEGORIES.map((c) => (
                      <option key={c.value} value={c.value}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="rv-field">
                  <label className="rv-label">Opis (min. 20 znaków)</label>
                  <textarea
                    className="rv-input rv-textarea"
                    rows={5}
                    placeholder="Podaj swojego maila, jeżeli chcesz otrzymać maila o roztrzygnięciu zgłoszenia"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>

                <div className="rv-check">
                  <input
                    className="rv-check__input"
                    type="checkbox"
                    checked={confirm}
                    onChange={(e) => setConfirm(e.target.checked)}
                    id="confirmReport"
                  />
                  <label className="rv-check__label" htmlFor="confirmReport">
                    Potwierdzam, że zgłoszenie jest rzetelne.
                  </label>
                </div>

                {error && <div className="alert alert-danger mt-3 mb-0">{error}</div>}

                <div className="rv-actions">
                  <button
                    type="button"
                    className="rv-btn rv-btn--ghost"
                    onClick={onClose}
                    disabled={loading}
                  >
                    Zamknij
                  </button>

                  <button
                    type="button"
                    className="rv-btn rv-btn--cta"
                    disabled={!canSubmit || loading}
                    onClick={submit}
                  >
                    {loading ? "Wysyłanie..." : "Wyślij zgłoszenie"}
                  </button>
                </div>
              </>
            )}

            {success && (
              <div className="rv-actions">
                <button type="button" className="rv-btn rv-btn--cta" onClick={onClose}>
                  Zamknij
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>,
  document.body
);
}
